import { all, takeEvery, put } from 'redux-saga/effects';
import siteConfig from '@iso/config/site.config';
import actions from './actions';
import { notification } from '@iso/components';
const gaxios = require('gaxios');
gaxios.instance.defaults = {
    baseURL: siteConfig.siteUrl.API_URL
}

export function* getNotasCierre() {
    const res = yield gaxios.request({
        url: 'api/notas-cierre',
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        yield put({
            type: actions.GET_NOTAS_CIERRE_SUCCESS,
            payload: res.data.notas,
        });
    }
}

export function* createNota({ payload }) {
    const res = yield gaxios.request({
        url: 'api/notas-cierre',
        method: 'POST',
        data: payload,
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        yield put({ type: actions.CREATE_NOTAS_CIERRE_SUCCESS, payload: res.data.nota });
        yield put({ type: actions.SET_CURRENT_NOTA_CIERRE, payload: res.data.nota });
    }
}

export function* editNota({ payload }) {
    const res = yield gaxios.request({
        url: 'api/notas-cierre/' + payload._id,
        method: 'PUT',
        data: payload,
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        yield put({ type: actions.EDIT_NOTAS_CIERRE_SUCCESS, payload: res.data.nota });
        yield put({ type: actions.SET_CURRENT_NOTA_CIERRE, payload: res.data.nota });
    }
}

export function* deleteNota({ payload }) {
    const res = yield gaxios.request({
        url: 'api/notas-cierre/' + payload,
        method: 'DELETE',
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        yield put({ type: actions.DELETE_NOTAS_CIERRE_SUCCESS, payload });
    }
}

export default function* rootSaga() {
    yield all([
        yield takeEvery(actions.GET_NOTAS_CIERRE_REQUEST, getNotasCierre),
        yield takeEvery(actions.CREATE_NOTAS_CIERRE_REQUEST, createNota),
        yield takeEvery(actions.EDIT_NOTAS_CIERRE_REQUEST, editNota),
        yield takeEvery(actions.DELETE_NOTAS_CIERRE_REQUEST, deleteNota),
    ]);
}
